export default "__VITE_ASSET__Bl11KtCE__"